<template>
  <nav v-if="page" class="forum-next-pagination" aria-label="Páginas de resultados">
    <router-link v-if="page.page > 1" :to="link(page.page - 1)" rel="prev">Anterior</router-link><span v-else aria-disabled="true">Anterior</span>
    <span>Página {{ number(page.page) }} de {{ number(page.pages) }}</span>
    <router-link v-if="page.page < page.pages" :to="link(page.page + 1)" rel="next">Siguiente</router-link><span v-else aria-disabled="true">Siguiente</span>
  </nav>
</template>
<script>
import { pageLink } from '../models/forumNavigation';
export default { name: 'ForumPagination', props: { page: Object }, methods: {
  link(page) { return pageLink(this.$route, page); }, number(value) { return new Intl.NumberFormat('es-ES').format(value); }
} };
</script>
